import { ItemsByHash } from '../../../../models/Order';
import { Member } from '../../../../models/Member';

export default (member: Member, itemsById: string[], itemsByHash: ItemsByHash) => (
  itemsById.filter((itemId: string) => (
    (!!itemsByHash[itemId].staffId && itemsByHash[itemId].staffId === member.userId)
      || itemsByHash[itemId].playerId === member.id
  ))
);
